import './ColumnItem.scss';

export { default } from './ColumnItem';
